import React, { FC } from "react";
import { isProductionReady } from "v3/config";
import Head from "next/head";

interface SignifydProps {
  orderSessionId: string;
}

export const Signifyd: FC<SignifydProps> = ({ orderSessionId }) => {
  if (isProductionReady) {
    return (
      <Head>
        <script
          defer
          type="text/javascript"
          id="sig-api"
          data-order-session-id={orderSessionId}
          src="https://cdn-scripts.signifyd.com/api/script-tag.js"
        ></script>
      </Head>
    );
  }
  return null;
};
